import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useSite } from "../context/SiteContext";

export function useCollection(name) {
  const { refresh } = useSite();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get(`/admin/${name}`).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [name]);
  useEffect(() => { load(); }, [load]);

  const run = async (fn, msg) => {
    try {
      await fn();
      if (msg) toast.success(msg);
      await load();
      refresh();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const strip = ({ id, created_at, ...rest }) => rest;
  return {
    items,
    setItems,
    create: (body, msg = "Added") => run(() => api.post(`/admin/${name}`, body), msg),
    save: (item, msg = "Saved") => run(() => api.put(`/admin/${name}/${item.id}`, strip(item)), msg),
    remove: (id, msg = "Deleted") => run(() => api.delete(`/admin/${name}/${id}`), msg),
    reload: load,
  };
}
